export default {
  loginIn: "登录",//登录按钮
  loginOut: "退出",
  currentAccount: "当前账号",
  emptyMsg: "当前账号下未发现角色,换个账号试试吧",
  validMsg: "最近一次在玩的游戏角色:",
  goNewGame: "开始新游戏",
  reLogin: "重新登录",
  loginDig: "登 录",//弹出框登录提示
  expirationTime: "30天内保持登录状态",
  goto: "前往",
  haveRoles: "查看其他已拥有角色",
  gameDes: "游戏介绍",
  moreGame: "更多游戏",
  // 邮箱登录
  forgetPas:"忘记密码?",
  changePas:"重置密码",
  passwordHolder:"请填写密码",
  codeHolder:"请填写验证码",
  getCode:"获取验证码",
  newPasswordHolder:"请填写新密码",
  newPasswordHolder2:"请再次填写新密码",
  newPasswordError:"两次输入密码不一致!",
  codeLimit:"长度在 4 到 6 个字符",
  passwordLimit:"长度在 4 到 20 个字符",
  loginSuccess:"登录成功",
  codeSend:"已发送验证码",
  pasSendSuccess:"密码修改成功",
  // 支付弹框
  pleaseConfirm: "请确认",
  payType: "支付方式",
  immediatePay: "立即支付",
  choosePayType: "请选择支付方式",
  // 导航部分
  recharge: "充值中心",
  persion: "个人中心",
  myGame: "我的游戏",
  myOrder: "我的订单",
  customer: "客户服务",
  hotQuestion: "热门问题",
  connectService: "联系客服",
  // 首页 footer
  address: "2013-2020",
  company: "游斐网络",
  aboutOur: "关于我们",
  careOur: "关注我们",
  agreement: "用户使用协议",
  privacy: "隐私政策",
  // 充值页面
  game: "游戏",
  gameHolder: "请选择游戏",
  server: "区服",
  serverHolder: "请选择区服",
  role: "角色",
  roleHolder: "请选择角色",
  rechargeGear: "充值档位",
  usuallyGoods: "日常礼包",
  limitGoods: "限定礼包",
  jfdh:"积分兑换",
  qiandao:"签到礼包",
  searchGoods: "搜索礼包",
  purchase: "购买",
  confirmAccount: "请确认账号",
  payconfirmHolder: "请确认是否充值",
  payContinue: "重新支付",
  payOver: "已完成支付",
  goodsEmpty: "请选择购买物品",
  payTipMsg1: "请您在新打开的页面完成支付！",
  payTipMsg2: "支付完成前请不要关闭此窗口。",
  // 我的游戏
  roleName: "角色名称",
  roleId: "角色ID",
  roleName: "角色名称",
  roleLeavel: "角色等级",
  vipLeavel: "vip等级",
  interestedGame: "可能感兴趣的游戏",
  playGame: "开始游戏",
  goRecharge: "去充值",
  // 我的订单
  dateTimeRange: "时间",
  startTime: "开始时间",
  endTime: "结束时间",
  to: "至",
  nickName: "昵称",
  goodsName: "礼包/金币",
  price: "价格",
  orderId: "订单号",
  rechargeTime: "充值时间",
  orderState: "订单状态",
  paySuccess: "支付成功",
  orderClose: "已关闭",
  doPay: "支付",
  doClose: "关闭",
  noData: "暂无数据",
  search: "查询",
  confirm: "确定",
  colseConfirm: "确定要关闭次订单吗?",
  colseSuccess: "关闭成功",
  tip: "提示",
  // 联系客服
  feedBack: "官网充值问题反馈",
  questionTime: "发生时间",
  questionTimeHolder: "请选择发生时间",
  email: "邮箱",
  emailHolder: "请填写邮箱",
  describe: "问题描述",
  describeHolder: "请填写问题描述",
  screenshot: "相关截图",
  cancel: "取消",
  submit: "提交",
  submitSuccess: "提交成功",
  emailNotEmpty: "邮箱不能为空",
  emailFormat: "请输入正确的邮箱格式",
  desEmpty: "问题描述不能为空",
  desMore: "问题描述不能超过255字",
  imgTypeError: "图片文件格式错误!",
  imgSizeError: "图片大小不能超过3MB!",
  // 公司介绍页面
  companyProfile: "公司简介",
  companyDes: "游斐网络成立于2013年，总部位于上海，创始成员来自盛大、果壳、蝴蝶互动等国内知名公司，是一家专业从事移动游戏自主研发、运营发行的综合游戏开发商。先后与三九互娱、广州思璞建立了互利共赢的良好合作伙伴关系。",
  developmentHis: "发展历程",
  developmentDes1: "游斐是一家充满朝气与活力的游戏公司。自2013年8月成立以来，公司队伍不断发展壮大，从成员结构单一到多个项目同时推进，逐步积累了丰富的移动游戏开发经验，产品覆盖多种游戏类型，致力于打造前所未有的完美游戏体验。",
  developmentDes2: "凭借自身强大的自研实力，游斐深耕移动游戏的自主研发，同时不断在运营发行等领域进行探索和拓展，加速提升自身品牌及行业影响力，积极推出高端精品游戏，塑造、维护健康良好的游戏生态。",
  developmentDes3: "在未来，游斐还将持续探索，推出更多诚意之作。",
  Telephone: "电话",
  Fax: "传真",
  country: "国家",
  countryHolder: "请选择国家",
  countryList: [
    { countryId: 360, countryName: '印度尼西亚', currency: "IDR" },
    // { countryId: 608, countryName: '菲律宾', currency: "PHP" },
    { countryId: 458, countryName: '马来西亚', currency: "MYR" },
    { countryId: 702, countryName: '新加坡', currency: "SGD" },
    // { countryId: 764, countryName: '泰国', currency: "THB" },
    // { countryId: 104, countryName: '缅甸', currency: "MMK" },
    // { countryId: 418, countryName: '老挝', currency: "LAK" },
    // { countryId: 116, countryName: '柬埔寨', currency: "USD" },
    // { countryId: 626, countryName: '东帝汶', currency: "USD" }
  ]
}


// WEBPACK FOOTER //
// ./src/common/lang/zh-CN.js